import {isEmpty, isNotNil} from 'ramda';

type HasSettledAllOffersListResponseParams = {
  data?: readonly unknown[];
  isEndReached?: boolean;
  isLoading: boolean;
  isFetching: boolean;
  /** False when the list RTK query is skipped (no filter body yet). */
  isListQueryEnabled: boolean;
};

/**
 * True when All Offers has a list response we can render without a full-table spinner:
 * visible rows, terminal list metadata, or a completed empty fetch.
 */
export function hasSettledAllOffersListResponse(
  params: HasSettledAllOffersListResponseParams
): boolean {
  if (!params.isListQueryEnabled) {
    return false;
  }

  if (isNotNil(params.data) && !isEmpty(params.data)) {
    return true;
  }

  if (params.isEndReached === true) {
    return true;
  }

  return isEmpty(params.data ?? []) && !params.isLoading && !params.isFetching;
}
